var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1684_219538)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.8784 4.95401L7.66577 14.166C7.60383 14.2282 7.53022 14.2775 7.44917 14.3112C7.36811 14.3449 7.28121 14.3622 7.19344 14.3622C7.10567 14.3622 7.01876 14.3449 6.93771 14.3112C6.85665 14.2775 6.78304 14.2282 6.7211 14.166L3.15844 10.6C3.0965 10.5378 3.02289 10.4885 2.94183 10.4548C2.86078 10.4211 2.77387 10.4038 2.6861 10.4038C2.59834 10.4038 2.51143 10.4211 2.43037 10.4548C2.34932 10.4885 2.27571 10.5378 2.21377 10.6C2.15159 10.6619 2.10224 10.7356 2.06858 10.8166C2.03491 10.8977 2.01758 10.9846 2.01758 11.0723C2.01758 11.1601 2.03491 11.247 2.06858 11.3281C2.10224 11.4091 2.15159 11.4827 2.21377 11.5447L5.77777 15.108C6.15374 15.4833 6.66324 15.694 7.19444 15.694C7.72564 15.694 8.23514 15.4833 8.6111 15.108L17.8231 5.89801C17.8852 5.83608 17.9344 5.76251 17.9681 5.68152C18.0017 5.60052 18.019 5.5137 18.019 5.42601C18.019 5.33832 18.0017 5.25149 17.9681 5.17049C17.9344 5.0895 17.8852 5.01593 17.8231 4.95401C17.7612 4.89182 17.6876 4.84248 17.6065 4.80881C17.5254 4.77514 17.4385 4.75781 17.3508 4.75781C17.263 4.75781 17.1761 4.77514 17.095 4.80881C17.014 4.84248 16.9404 4.89182 16.8784 4.95401Z",
    fill: "#FAFAFA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1684_219538"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(2 2)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckWhite);
export default __webpack_public_path__ + "static/media/check-white.6fdc93a4efbbbfdd75a657cea58092c9.svg";
export { ForwardRef as ReactComponent };